import { render } from "./LoginFormv2.vue?vue&type=template&id=474ad4d0&scoped=true"
import script from "./LoginFormv2.vue?vue&type=script&lang=js"
export * from "./LoginFormv2.vue?vue&type=script&lang=js"

import "./LoginFormv2.vue?vue&type=style&index=0&id=474ad4d0&lang=scss&scoped=true"

import exportComponent from "/home/forge/s.thebuyhive.com/expertsourcing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-474ad4d0"]])

export default __exports__